import React from 'react';
import { IMaskInput } from 'react-imask';

export const PhoneInput = ({className, required=false, onBlur, tabIndex, changeHandler, value, mask = '0 (000) 000-00-00'}) => {
    return (
        <IMaskInput
          mask={mask}
          className={className}
          required={required}
          value={value}
          onAccept={(value) => changeHandler({ target: { value } })}
          onBlur={onBlur}
          tabIndex={tabIndex}
        />
      );
}
